<template>
  <div class="position-relative">
    <div
      class="dropdown position-absolute"
      style="z-index: 1; top:10px; left: 12px;">
      <a class="btn btn-primary" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa fa-bars"/>
      </a>
  
      <ul
        class="dropdown-menu p-1"
        aria-labelledby="dropdownMenuLink">
        <li><small class="text-muted px-3">Dashboard View</small></li>
        <li><hr class="dropdown-divider"></li>
        <li>
          <a
            class="dropdown-item" href="#"
            :class="{active: dashboardView == 'customer'}"
            @click="setView('customer')">
            Customers
          </a>
        </li>
        <li>
          <a
            class="dropdown-item" href="#"
            :class="{active: dashboardView == 'manageDisplays'}"
            @click="setView('manageDisplays')">
            Manage Displays
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    props: ['dashboardView'],
    methods:{
      setView(view){
        this.$emit('setView', view)
      }
    }
  }
</script>